import React from 'react'

const DownPage = () => {
  return (
    <>
    <div className="down">
        
    </div>
    
    </>
  )
}

export default DownPage